<div class="main-div">
  <h1 class="main-header-text">Specijalni dani</h1>
  <!---Table--->
  <div class="flex table-top-area">
    <div>
      <app-search></app-search>
    </div>
    <div class="add-station-div">
      <button mat-icon-button disableRipple (click)="openDialog()">
        <mat-icon svgIcon="add" class="add" matTooltip="Kreiraj specijalni dan"></mat-icon>
      </button>
    </div>
  </div>
  <!---Table--->
  <table class="table-style" mat-table [dataSource]="data" matSort>
    <ng-container matColumnDef="ID_SPECIAL_DAY">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="id" id="special_id">ID</th>
      <td mat-cell *matCellDef="let element">
        {{ element.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="DAY">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="day" id="day">Dan</th>
      <td mat-cell *matCellDef="let element">
        {{ element.day }}
      </td>
    </ng-container>

    <ng-container matColumnDef="MONTH">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="month" id="month">Mesec</th>
      <td mat-cell *matCellDef="let element">
        {{ element.month }}
      </td>
    </ng-container>

    <ng-container matColumnDef="YEAR">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="startYear" id="year">Godina</th>
      <td mat-cell *matCellDef="let element">
        {{ checkYear(element.startYear) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="NAME">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Naziv</th>
      <td mat-cell *matCellDef="let element">{{ element.name }}</td>
    </ng-container>

    <ng-container matColumnDef="ACTION">
      <th mat-header-cell *matHeaderCellDef class="p-0">Akcije</th>
      <td mat-cell *matCellDef="let element" class="cell-size-actions">
        <div class="cell-actions">
          <button mat-icon-button (click)="getById(element.id)">
            <mat-icon svgIcon="edit" class="edit" matTooltip="Ažuriraj"></mat-icon>
          </button>
          <button mat-icon-button (click)="deleteDialog(element)">
            <mat-icon svgIcon="delete" class="delete" matTooltip="Obriši"></mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <div class="paginator">
    <mat-paginator [length]="total" [pageSize]="10" [hidePageSize]="true" [showFirstLastButtons]="true">
    </mat-paginator>
  </div>
</div>
